module.exports = __webpack_public_path__ + "static/mobile.h264-7dd26901c90a1367b0891ce9650c4e44.mp4";